import React from "react";
import { useEffect } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";

import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";

import ContactUsBanner from "components/user/ContactUsBanner";
import SocialBanner from "components/user/SocialBanner";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fullWidth: {
      marginLeft: "calc(50% - 50vw)",
      marginRight: "calc(50% - 50vw)",
    },
    section: {
      paddingBottom: "1.875rem",
      paddingTop: "50px",
      "@media (min-width: 30.0625em)": {
        paddingBottom: "2.625rem",
      },
      "@media (min-width: 48.0625em)": {
        paddingBottom: "3.5rem",
      },
    },
    iframe: {
      minHeight: "800px",
      marginTop: theme.spacing(1),
      [theme.breakpoints.down("xs")]: {
        minHeight: "950px",
      },
    },
  })
);

export default function RegisterDemo() {
  const classes = useStyles();

  useEffect(() => {
    document.title = "Register a demo - Hedge Fund Alert";
  }, []);

  return (
    <div className="news-alerts-landing-container">
      <Box className={clsx(classes.fullWidth, classes.section)}>
        <Container>
          <Typography variant="h1" component="h2" gutterBottom>
            Book a demo and step into our world
          </Typography>

          <Typography variant="body1" gutterBottom>
            There’s only one way to truly appreciate the value of the HFA
            platform - seeing it for yourself. Enter your details and we’ll be
            in touch to schedule a demo.
          </Typography>

          <iframe
            allowTransparency
            title="iframe-register-demo"
            src="https://pardot.pageantmedia.com/l/284832/2021-07-29/dztg8k"
            width="100%"
            className={classes.iframe}
            frameBorder={0}
            style={{ border: 0 }}
          />
        </Container>
      </Box>

      <ContactUsBanner />

      <SocialBanner />
    </div>
  );
}
